import { Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${Color.Gray100};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: ${AppZIndex.LoadingScreen};
  inset: 0;
  position: fixed;
`;

export const Container = styled.div`
  width: 100%;
  flex: 1;
  flex-grow: 999;
  min-height: 500px;
  background-color: ${Color.Gray100};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
`;

export const Description = styled.div`
  font-size: 20px;
  line-height: 28px;
  max-width: 300px;
  text-align: center;
`;
